export default __webpack_public_path__ + "static/media/at_light.ac793708.png";